<template>
	<AsiDialogFormLayout :title="$t('brand.terms.update')" :open="open" :loading="loading" :valid="valid"
	                     :errors="errors" @save="requestSave" @cancel="cancel" unwrapped scrollable>
		<v-card-text>
			<v-form v-if="updateModel !== null" v-model="valid">
				<div class="pa-6">
					<AsiTextField v-model="updateModel.name" :rules="updateModel.rules('name')"
					              :label="$t('brand.name')" :placeholder="$t('brand.name')"
					              clearable/>
				</div>
				<v-divider/>
				<div class="pa-6">
					<TranslatedValueFormPart :label="$t('brand.description')" :model="updateModel.description" text-area/>
				</div>
				<v-divider/>
			</v-form>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Watch} from 'vue-property-decorator';
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import AsiTextField from "@/components/common/AsiTextField";
	import TranslatedValueFormPart from "@/components/translated-value/admin/TranslatedValueFormPart.vue";
	import {IBrandAdmin} from "@/models/brand/BrandAdminModels";
	import BrandUpdate from "@/models/brand/BrandUpdate";

	@Component({
		components: {TranslatedValueFormPart, AsiTextField, AsiDialogFormLayout}
	})
	export default class BrandUpdateDialog extends AsiDialogForm {

		@Prop({type: Object, required: true})
		public brand!: IBrandAdmin | null;

		private updateModel: BrandUpdate | null = null;

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			const form = this.$refs.form as HTMLFormElement;
			this.reset([], form);
			return event;
		}

		@Watch('brand', {immediate: true})
		private onBrandChanged(): void {
			if (this.brand !== null) {
				this.updateModel = new BrandUpdate(this.brand);
				this.valid = true;
			}
		}

		private requestSave(): void {
			if (!this.valid || !this.brand || !this.updateModel) return;
			this.loading = true;
			this.$brandServiceAdmin.update(this.brand.id, this.updateModel)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}
	}
</script>

<style scoped lang="scss">

</style>
